export default __webpack_public_path__ + "static/media/logo.6cb46e70.png";